import React from 'react';
import { useMount } from 'react-use';
import GiftCardFaqSection from '~/components/GiftCards/GiftCardFAQSection';
import GiftCardHighlights from '~/components/GiftCards/GiftCardHighlights';
import GiftCardPageHero from '~/components/GiftCards/GiftCardPageHero';
import Layout from '~/components/Layout';
import { useModals } from '~/contexts/ModalsContext';
import { useSession } from '~/contexts/SessionContext';
import { visitedGiftCards } from '~/services/analytics/events/giftCards';

interface Props {}

const GiftCardPage: React.FC<Props> = () => {
  const modals = useModals();
  const { loggedIn } = useSession();

  useMount(visitedGiftCards);

  function openRedeemGiftCardModal() {
    if (loggedIn) {
      modals.openModal('redeemGiftCard', {});
    } else {
      modals.openModal('loginRegister', {
        contextMessage:
          'To redeem your gift card, sign in or create a SidelineSwap account',
        defaultView: 'login',
        onSuccessfulLogin: () => modals.openModal('redeemGiftCard', {}),
        src: 'gift-cards',
      });
    }
  }

  return (
    <>
      <GiftCardPageHero onRedeemGiftCard={openRedeemGiftCardModal} />

      <div className="container">
        <h2 className="mb-6 text-center">The perfect gift for every athlete</h2>
        <p className="mb-4 text-center text-lg md:mb-8">
          With countless options and unbeatable prices on new and used gear,
          there’s always a deal waiting to be discovered.
        </p>

        <GiftCardHighlights />
        <GiftCardFaqSection />
      </div>
    </>
  );
};

const GiftCardPageContent: React.FC<Props> = props => (
  <Layout title="SidelineSwap Gift Cards" container={false}>
    <GiftCardPage {...props} />
  </Layout>
);

export default GiftCardPageContent;
